'use strict';

/**
 * 骨架屏公共模块 — 单一源码，服务端 (baseController) 和客户端 (withSSR) 共享
 *
 * 约束：
 *  - 纯 CJS (module.exports)，不使用 import/export、async/await、JSX
 *  - 使用 var/function 避免任何 babel transform 引入 import helper
 *  - 这样 Node require() 和 webpack import 均可正常使用
 */

var SSR_CONTENT_HEIGHT = '500px';

/**
 * 创建骨架屏 React 元素
 * @param {Object} React - React 引用（由调用方传入，避免此文件 require('react')）
 * @returns {ReactElement} 骨架屏元素
 */
function createSkeletonElement(React) {
  var h = React.createElement;

  var bone = function (w, ht, mb) {
    return {
      width: w,
      height: ht,
      borderRadius: '4px',
      marginBottom: mb || '12px',
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
      backgroundSize: '800px 100%',
      animation: 'shimmer 1.6s ease-in-out infinite',
      flexShrink: 0,
    };
  };

  var card = { flex: 1, borderRadius: '8px', background: '#fafafa', padding: '20px' };

  return h(
    'div',
    {
      style: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '32px 24px',
        minHeight: SSR_CONTENT_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      },
    },
    h('style', {
      dangerouslySetInnerHTML: {
        __html:
          '@keyframes shimmer{0%{background-position:-800px 0}100%{background-position:800px 0}}',
      },
    }),
    h('div', { style: bone('45%', '24px', '24px') }),
    h('div', { style: bone('30%', '16px', '32px') }),
    h(
      'div',
      { style: { display: 'flex', gap: '16px', marginBottom: '24px', flexShrink: 0 } },
      [1, 2, 3].map(function (i) {
        return h(
          'div',
          { key: i, style: card },
          h('div', { style: bone('60%', '14px') }),
          h('div', { style: bone('40%', '28px') }),
          h('div', { style: bone('80%', '12px', '0') })
        );
      })
    ),
    h(
      'div',
      {
        style: {
          borderRadius: '8px',
          background: '#fafafa',
          padding: '24px',
          marginBottom: '24px',
          flexShrink: 0,
        },
      },
      h('div', { style: bone('35%', '18px', '20px') }),
      h('div', { style: bone('100%', '14px') }),
      h('div', { style: bone('100%', '14px') }),
      h('div', { style: bone('75%', '14px', '0') })
    ),
    h(
      'div',
      { style: { display: 'flex', gap: '16px', flex: 1, minHeight: 0 } },
      h(
        'div',
        { style: { flex: 2, borderRadius: '8px', background: '#fafafa', padding: '20px' } },
        h('div', { style: bone('50%', '16px', '16px') }),
        h('div', {
          style: {
            width: '100%',
            flex: 1,
            borderRadius: '4px',
            background:
              'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
            backgroundSize: '800px 100%',
            animation: 'shimmer 1.6s ease-in-out infinite',
          },
        })
      ),
      h(
        'div',
        {
          style: {
            flex: 1,
            borderRadius: '8px',
            background: '#fafafa',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
          },
        },
        h('div', { style: bone('60%', '16px', '16px') }),
        h('div', { style: bone('100%', '14px') }),
        h('div', { style: bone('100%', '14px') }),
        h('div', { style: bone('100%', '14px') }),
        h('div', { style: bone('50%', '14px', '0') })
      )
    )
  );
}

module.exports = { createSkeletonElement: createSkeletonElement, SSR_CONTENT_HEIGHT: SSR_CONTENT_HEIGHT };
